
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/oauth-sdk",
      function () {
        return require("private-next-pages/products/oauth-sdk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/oauth-sdk"])
      });
    }
  